var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        width: "460px",
        "show-close": false,
        "custom-class": "confirm-dialog is-" + _vm.kind,
        "append-to-body": "",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.innerVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "confirm-wrap" }, [
        _c("div", { staticClass: "cw-head" }, [
          _c("span", { staticClass: "cw-ico", class: _vm.icoCls }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "14",
                  height: "14",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                },
              },
              [
                _vm.kind === "danger"
                  ? _c("path", {
                      attrs: {
                        d: "M10.3 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.7 3.86a2 2 0 0 0-3.4 0z",
                      },
                    })
                  : _vm._e(),
                _vm.kind === "danger"
                  ? _c("path", { attrs: { d: "M12 9v4.4" } })
                  : _vm._e(),
                _vm.kind === "danger"
                  ? _c("circle", {
                      attrs: {
                        cx: "12",
                        cy: "16.8",
                        r: "1.1",
                        fill: "currentColor",
                        stroke: "none",
                      },
                    })
                  : [
                      _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
                      _c("path", { attrs: { d: "M12 7.4v5.6" } }),
                      _c("circle", {
                        attrs: {
                          cx: "12",
                          cy: "16.6",
                          r: "1.15",
                          fill: "currentColor",
                          stroke: "none",
                        },
                      }),
                    ],
              ],
              2
            ),
          ]),
          _c("div", { staticClass: "cw-title" }, [
            _c("span", [_vm._v(_vm._s(_vm.title))]),
            _vm.titlePt
              ? _c("span", { staticClass: "cw-pt" }, [
                  _vm._v(_vm._s(_vm.titlePt)),
                ])
              : _vm._e(),
          ]),
        ]),
        _c("div", { staticClass: "cw-body" }, [
          _vm.subtitle
            ? _c("div", { staticClass: "cw-sub" }, [
                _vm._v(_vm._s(_vm.subtitle)),
              ])
            : _vm._e(),
          _c("div", {
            staticClass: "cw-desc",
            domProps: { innerHTML: _vm._s(_vm.desc) },
          }),
          _vm.descPt
            ? _c("div", {
                staticClass: "cw-desc pt",
                domProps: { innerHTML: _vm._s(_vm.descPt) },
              })
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "cw-footer", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.innerVisible = false
                },
              },
            },
            [
              _c("bi-label", {
                attrs: { zh: "取消", pt: "Cancelar", inline: "" },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: _vm.okType },
              on: { click: _vm.handleOk },
            },
            [
              _vm._v(" " + _vm._s(_vm.okText)),
              _vm.okTextPt
                ? _c("span", { staticClass: "btn-pt" }, [
                    _vm._v(" / " + _vm._s(_vm.okTextPt)),
                  ])
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }